import React from 'react';
import { Switch, Button } from 'antd';
import type {
  Channel,
  StateConfig,
} from 'services/NotificationTemplatesService';
import { useTemplate } from 'services/NotificationTemplatesService';
import useStyles from './styles';
import TemplatePreview from './TemplatePreview';

interface StateCardProps {
  classes: ReturnType<typeof useStyles>;
  channel: Channel;
  state: StateConfig;
  onToggle: (enabled: boolean) => void;
  onPreview: () => void;
  onEditOrMap: () => void;

  onRemove: () => void;
}

const EmailThumb = ({
  classes,
  title,
}: {
  classes: ReturnType<typeof useStyles>;
  title: string;
}) => (
  <div className={classes.mini}>
    <div className={classes.miniHead}>
      <span>Chazki</span>
      <span>◉</span>
    </div>
    <div className={classes.miniBody}>
      <div className={classes.miniTitle}>{title}</div>
      <div className={classes.miniLine} style={{ width: '85%' }} />
      <div className={classes.miniLine} style={{ width: '55%' }} />
    </div>
  </div>
);

const WspThumb = ({
  classes,
  title,
}: {
  classes: ReturnType<typeof useStyles>;
  title: string;
}) => (
  <div className={classes.wmini}>
    <div className={classes.bubble}>
      <div className={classes.bubbleTitle}>{title}</div>
      <div className={classes.bubbleLine} style={{ width: '85%' }} />
      <div className={classes.bubbleLine} style={{ width: '65%' }} />
    </div>
  </div>
);

const StateCard = ({
  classes,
  channel,
  state,
  onToggle,
  onPreview,
  onEditOrMap,
  onRemove,
}: StateCardProps) => {
  const isWsp = channel === 'whatsapp';

  const { data: realTpl } = useTemplate(
    isWsp ? undefined : state.templateId,
    !isWsp && !!state.templateId,
  );
  const cardClass = `${classes.scard}${state.enabled ? '' : ` ${classes.scardOff}`}`;
  const codeClass = `${classes.scode}${state.enabled ? ` ${classes.scodeOn}` : ''}`;

  return (
    <div className={cardClass}>
      <div className={classes.scardTop}>
        <span className={codeClass}>{state.stateCode}</span>
        <span className={classes.sname}>{state.stateName}</span>
        <span className={classes.swToggle}>
          <Switch
            size="small"
            checked={state.enabled}
            onChange={onToggle}
            aria-label={`Notificar ${state.stateName}`}
          />
        </span>
        <span
          role="button"
          tabIndex={0}
          title="Quitar estado del carrusel"
          onClick={onRemove}
          style={{
            marginLeft: 6,
            color: '#bfbfbf',
            cursor: 'pointer',
            fontSize: 13,
            lineHeight: 1,
          }}
        >
          ✕
        </span>
      </div>
      <div className={classes.thumb}>
        {isWsp ? (
          <WspThumb classes={classes} title={state.stateName} />
        ) : realTpl ? (

          <div
            style={{
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              background: '#fff',
            }}
          >
            <div
              style={{
                width: 300,
                transform: 'scale(0.6)',
                transformOrigin: 'top left',
                pointerEvents: 'none',
              }}
            >
              <TemplatePreview
                classes={classes}
                blocks={realTpl.blocks}
                brandColor={realTpl.brandColor}
              />
            </div>
          </div>
        ) : (
          <EmailThumb classes={classes} title={state.stateName} />
        )}
      </div>
      <div className={classes.plName}>
        <span className={classes.plTag}>
          {isWsp ? state.wspTemplateName : `#${state.stateCode}`}
        </span>
        {isWsp ? 'es' : state.templateName}
      </div>
      <div className={classes.sbtns}>
        <Button size="small" onClick={onPreview}>
          Vista previa
        </Button>
        <Button size="small" onClick={onEditOrMap}>
          {isWsp ? 'Ver mapeo' : 'Editar'}
        </Button>
      </div>
    </div>
  );
};

export default StateCard;
